export enum FinanceIntegration {
	"Salesforce PaymentCenter" = 1,
	"Quickbooks Online" = 2,
	"Xero" = 3,
}
